import React, { FC, useCallback } from 'react';
import { useIntl } from 'react-intl';
import { Query } from '@material-table/core';
import { MTable, Panel } from '../../../../../../Components';
import { useAptorApi } from '../../../../../../Api';
import { IGridQueryRequest, OrderDirection } from '../../../../../../Api/AptorApi';

interface IUnacknowledgedChange {
  changeId: number;
  changeName: string;
  complianceUser: string;
}

export const UnacknowledgedChanges: FC<{ reqId: number }> = ({ reqId }) => {
  const { api } = useAptorApi();
  const { formatMessage } = useIntl();

  const handleDataFetch = useCallback(
    async (query: Query<IUnacknowledgedChange>) => {
      return await api.searchUnacknowledgedRequirementChanges<IUnacknowledgedChange>(reqId, {
        orderDirection: query.orderDirection === 'desc' ? OrderDirection.Descending : OrderDirection.Ascending,
        orderBy: query.orderBy !== undefined ? query.orderBy.field : 'changeName',
        page: query.page,
        pageSize: query.pageSize,
        search: query.search,
      } as IGridQueryRequest);
    },
    [reqId, api],
  );

  return (
    <Panel titleKey="law-portal.our-laws.changes.unacknowledged-changes.label">
      <MTable
        hideToolbar
        columns={[
          {
            title: formatMessage({ id: 'law-portal.our-laws.changes.unacknowledged-changes.table.name' }),
            field: 'changeName',
          },
          {
            title: formatMessage({ id: 'law-portal.our-laws.changes.unacknowledged-changes.table.complianceUsers' }),
            field: 'complianceUser',
            sorting: false,
          },
        ]}
        data={handleDataFetch}
        components={{}}
      />
    </Panel>
  );
};
